import { useEffect, useState } from "react";
import {
  Box,
  TextField,
  Typography,
  Button,
  Stack,
} from "@mui/material";
import { motion } from "framer-motion";
import { useDispatch, useSelector } from "react-redux";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { toast } from "react-toastify";
import CreatableSearch from "../../../Base/views/CreatableSearch";
import { GetAtsPythonAIJobCreationAction } from "../../../../../store/ATS/ProfileScore/Action";
import AutoModeIcon from "@mui/icons-material/AutoMode";

const AICreateJobFlowDetails = ({
  handleIndustryTypeLoading,
  industrytype,
  handleJobTemplateLoading,
  jobTitle,
  handleSkillsLoading,
  skills,
  handleSkillsLoading2,
  skills2,
  handleChange,
  jobPostData,
  setPostJobData,
  setRolesResponsibilities,
  setDescription,
  setSelectedOption,
}) => {
  const dispatch = useDispatch();
  const [step, setStep] = useState(0);
  const [errors, setErrors] = useState({});
  const { pythonJobCreationLoading } = useSelector(
    (state) => state.AtsReducer?.AtsProfileScoreReducer
  );

  const [slideMessage, setSlideMessage] = useState(null);
  const handleValChange = (event, value) => {
    handleChange(event, value);
  };
  useEffect(() => {
    Object.values?.(errors)?.find((res) => res !== "")?.length > 0 &&
      validateStep();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [jobPostData]);
  const steps = [
    {
      id: "industry_type",
      label: "Industry Sector",
      component: (
        <CreatableSearch
          isOptionEqualToValue={(option, value) =>
            +option.industry_name === +value.industry_name
          }
          label="Industry Sector"
          value={jobPostData?.industry_type}
          fieldLabel="industry_name"
          loading={() => handleIndustryTypeLoading()}
          required={true}
          variant={"contained"}
          noOptionText="Start typing to add or select industry"
          name="industry_type"
          size="small"
          data={industrytype}
          onChangeEvent={handleValChange}
          {...(errors.industry_type && {
            error: true,
            helperText: errors.industry_type,
          })}
        />
      ),
      show: true,
    },
    {
      id: "title",
      label: "Job Title",
      component: (
        <CreatableSearch
          isOptionEqualToValue={(option, value) =>
            +option.job_template_id === +value.job_template_id
          }
          label="Job Title"
          value={jobPostData?.title}
          noOptionText="Please select Industry Sector to choose title"
          fieldLabel="job_title"
          loading={() => handleJobTemplateLoading()}
          required={true}
          variant={"contained"}
          name="title"
          size="small"
          data={jobTitle}
          onChangeEvent={handleValChange}
          {...(errors.title && {
            error: true,
            helperText: errors.title,
          })}
        />
      ),
      show: true,
    },
    {
      id: "primary_skill",
      label: "Primary Skills",
      component: (
        <CreatableSearch
          isOptionEqualToValue={(option, value) => option.skill === value.skill}
          label="Primary Skills"
          value={jobPostData?.primary_skill}
          fieldLabel="skill"
          loading={handleSkillsLoading}
          required={true}
          variant={"contained"}
          name="primary_skill"
          size="small"
          optionLabel="skill"
          multiple={true}
          data={skills}
          onChangeEvent={handleValChange}
          {...(errors.primary_skill && {
            error: true,
            helperText: errors.primary_skill,
          })}
        />
      ),
      show: true,
    },
    {
      id: "min_exp_required",
      label: "Minimum Experience",
      component: (
        <TextField
          name="min_exp_required"
          label="Minimum Experience"
          size="small"
          placeholder="2"
          type="number"
          required
          onChange={handleValChange}
          fullWidth
          onKeyPress={(e) => e.target.value?.length > 2 && e.preventDefault()}
          onPaste={(e) => e.target.value?.length > 2 && e.preventDefault()}
          variant="outlined"
          value={jobPostData.min_exp_required || ""}
          {...(errors.min_exp_required && {
            error: true,
            helperText: errors.min_exp_required,
          })}
        />
      ),
      show: true,
    },
    {
      id: "max_exp_required",
      label: "Maximum Experience",
      component: (
        <TextField
          name="max_exp_required"
          label="Maximum Experience"
          size="small"
          placeholder="5"
          type="number"
          required
          onChange={handleValChange}
          onKeyPress={(e) => e.target.value?.length > 2 && e.preventDefault()}
          onPaste={(e) => e.target.value?.length > 2 && e.preventDefault()}
          fullWidth
          variant="outlined"
          value={jobPostData.max_exp_required || ""}
          {...(errors.max_exp_required && {
            error: true,
            helperText: errors.max_exp_required,
          })}
        />
      ),
      show: true,
    },
    {
      id: "secondary_skill",
      label: "Secondary Skills",
      component: (
        <CreatableSearch
          isOptionEqualToValue={(option, value) => option.skill === value.skill}
          label="Secondary Skills"
          value={jobPostData?.secondary_skill}
          fieldLabel="skill"
          noOptionText="Please select Industry Sector to choose skills"
          optionLabel="skill"
          multiple={true}
          loading={handleSkillsLoading2}
          variant={"contained"}
          name="secondary_skill"
          size="small"
          data={skills2}
          onChangeEvent={handleValChange}
          {...(errors.secondary_skill && {
            error: true,
            helperText: errors.secondary_skill,
          })}
        />
      ),
      show: true,
    },
  ];
  const filteredSteps = steps?.filter((step) => step?.show);

  const validateStep = () => {
    let newErrors = {};
    const currentStepId = filteredSteps[step]?.id;
    switch (currentStepId) {
      case "title":
        if (!jobPostData.title?.job_title) {
          newErrors.title = "Job Title is required.";
        }
        break;
      case "industry_type":
        if (jobPostData?.industry_type?.length === 0) {
          newErrors.industry_type = "Industry Sector is required.";
        } else if (jobPostData?.industry_type === null) {
          newErrors.industry_type = "Industry Sector is required.";
        }
        break;
      case "primary_skill":
        if (jobPostData?.primary_skill?.length === 0) {
          newErrors.primary_skill = "Primary Skill is required.";
        } else if (jobPostData?.primary_skill === null) {
          newErrors.primary_skill = "Primary Skill is required.";
        }
        break;
      case "max_exp_required":
        if (
          jobPostData.max_exp_required &&
          jobPostData.min_exp_required &&
          +jobPostData.max_exp_required < +jobPostData.min_exp_required
        ) {
          newErrors.max_exp_required =
            "Maximum experience must be lesser than minimum experience.";
        }
        break;
      default:
        break;
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleNext = () => {
    if (!validateStep()) return;
    const currentStep = filteredSteps[step];
    const currentLabel = currentStep?.label;
    const currentValue = (() => {
      switch (currentStep?.id) {
        case "title":
          return jobPostData.title?.job_title || "";
        case "industry_type":
          return jobPostData?.industry_type?.industry_name || "";
        case "primary_skill":
          return (
            jobPostData?.primary_skill?.map((el) => el?.skill)?.join(", ") || ""
          );
        case "max_exp_required":
          return jobPostData?.max_exp_required
            ? `${jobPostData?.max_exp_required} year(s)`
            : "";
        case "min_exp_required":
          return jobPostData?.min_exp_required
            ? `${jobPostData?.min_exp_required} year(s)`
            : "";
        case "secondary_skill":
          return (
            jobPostData?.secondary_skill?.map((el) => el?.skill)?.join(", ") ||
            ""
          );
        default:
          return "";
      }
    })();

    setSlideMessage(null);
    setTimeout(() => {
      setSlideMessage(`${currentLabel} : ${currentValue}`);
    }, 10);

    if (step < filteredSteps.length - 1) {
      setStep(step + 1);
    } else {
      const payload = {
        industry_sector: jobPostData?.industry_type?.industry_name,
        job_title: jobPostData.title?.job_title,
        skills: `${jobPostData?.primary_skill
          ?.map((el) => el?.skill)
          ?.join(", ")},${jobPostData?.secondary_skill
          ?.map((el) => el?.skill)
          ?.join(", ")}`,
        years_of_experience: jobPostData?.experience,
      };
      dispatch(
        GetAtsPythonAIJobCreationAction(
          {
            job_data: [payload],
          },
          (error, result) => {
            if (!error && result?.data) {
              setRolesResponsibilities(
                result?.data?.roles_and_responsibilities
              );
              setDescription(result?.data?.job_description);
              setSelectedOption("");
              setPostJobData((prev) => {return {...prev, is_ai_job: true}})
            } else {
              toast.error("Something went wrong");
            }
          }
        )
      );
    }
  };

  const handleBack = () => {
    if (step > 0) {
      setStep(step - 1);
      setSlideMessage(null);
    }
  };

  return (
    <Box
      sx={{
        width: "100%",
        maxWidth: "500px",
        margin: "auto",
        display: "flex",
        flexDirection: "column",
        gap: "15px",
        textAlign: "center",
      }}
    >
      <Box>
        <Typography variant="h4" gutterBottom>
          {filteredSteps[step].label}
        </Typography>
      </Box>
      <Box>
        <Box
          sx={{
            minHeight: "100px",
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-start",
            justifyContent: "center",
            gap: 4
          }}
        >
          <Box height="40px" minWidth={0} maxWidth={"100%"}>
            {slideMessage && (
              <motion.div
                initial={{ scale: 0.95, opacity: 0 }}
                animate={{ scale: 1, opacity: 1 }}
                exit={{ scale: 0.95, opacity: 0 }}
                transition={{ duration: 2 }}
                style={{
                  transform: "translateX(-50%)",
                  backgroundColor: `
                                  radial-gradient(circle at 20% 30%, rgba(179,136,235,0.12) 0%, transparent 50%),
                                  radial-gradient(circle at 80% 20%, rgba(244,143,177,0.12) 0%, transparent 50%),
                                  radial-gradient(circle at 50% 80%, rgba(135,206,235,0.1) 0%, transparent 50%)
                                `,
                  color: "black",
                  padding: "10px 16px",
                  borderRadius: "6px",
                  border: "1px solid rgb(243,237,253)",
                  fontSize: "16px",
                  boxShadow: "0 8px 30px rgba(99, 102, 241, 0.25)",
                  zIndex: 10,
                  maxWidth: "100%",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  pointerEvents: "none",
                  mb: 2,
                  textAlign: "start"
                }}
              >
                {slideMessage}
              </motion.div>
            )}
          </Box>
          <motion.div
            key={step}
            initial={{ opacity: 0, x: 50 }}
            animate={{ opacity: 1, x: 0 }}
            exit={{ opacity: 0, x: -50 }}
            transition={{ duration: 0.5 }}
            style={{
              width: "100%",
            }}
            onKeyDown={(e) => {
              if (e.key === "Enter") handleNext();
            }}
          >
            {filteredSteps[step].component}
          </motion.div>
        </Box>
        <Box
          sx={{
            display: "flex",
            justifyContent: "flex-end",
            gap: "20px",
            mt: 2
          }}
        >
          <Button
            onClick={handleBack}
            disabled={step === 0}
            variant="contained"
            sx={{
              width: "40px",
              height: "40px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              padding: "12px",
              backgroundColor: "#fecb03",
              visibility: step === 0 ? "hidden" : "visible",
              minWidth: "unset",
              "&:hover": {
                backgroundColor: "#fecb03",
              },
            }}
          >
            <ArrowForwardIosIcon
              sx={{
                fontSize: "28px",
                color: "black",
                transform: "rotate(180deg)",
              }}
            />
          </Button>
          <Button
            onClick={() => !pythonJobCreationLoading && handleNext()}
            variant="contained"
            sx={{
              width: "40px",
              height: "40px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              padding: "12px",
              cursor: pythonJobCreationLoading ? "not-allowed" : "default",
              backgroundColor: "#fecb03",
              minWidth: "unset",
              "&:hover": {
                backgroundColor: "#fecb03",
              },
            }}
          >
            {step < filteredSteps.length - 1 ? (
              <ArrowForwardIosIcon sx={{ fontSize: "28px", color: "black" }} />
            ) : (
              <AutoModeIcon 
                sx={{
                  fontSize: "32px", 
                  color: "black",
                  animation:
                      pythonJobCreationLoading
                      ? "spin 1s linear infinite"
                      : "none",
                  "@keyframes spin": {
                      "0%": { transform: "rotate(0deg)" },
                      "100%": { transform: "rotate(360deg)" },
                  },
                }}
              />              
            )}
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

const JobInfoPreview = ({ jobPostData = {} }) => {
  const {
    title,
    industry_type,
    primary_skill,
    secondary_skill,
    min_exp_required,
    max_exp_required,
  } = jobPostData;

  const renderField = (label, value, placeholder) => (
    <Box>
      <Typography
        sx={{
          fontSize: "0.85rem",
          color: "text.primary",
          fontWeight: 600,
          mb: 0.5,
        }}
      >
        {label}
      </Typography>
      <Typography
        sx={{
          fontSize: "0.95rem",
          color: value ? "text.secondary" : "text.disabled",
          wordWrap: "break-word",
          whiteSpace: "normal",
          overflowWrap: "anywhere",
          lineHeight: 1.4,
        }}
      >
        {value?.length ? value : placeholder}
      </Typography>
    </Box>
  );

  return (
    <Stack spacing={2}>
      {renderField(
        "Industry",
        industry_type?.industry_name,
        "Industry not specified"
      )}
      {renderField("Job Title", title?.job_title, "Job Title not specified")}
      {renderField(
        "Skills",
        primary_skill?.length || secondary_skill?.length
          ? `${[...primary_skill, ...secondary_skill]
              ?.map((el) => el?.skill)
              ?.join(", ")}`
          : "",
        "No skills added"
      )}
      {/* Experience */}
      <Box>
        <Typography
          sx={{
            fontSize: "0.85rem",
            color: "text.primary",
            fontWeight: 600,
            mb: 0.5,
          }}
        >
          Experience
        </Typography>
        <Typography
          sx={{
            fontSize: "0.95rem",
            color:
              min_exp_required || max_exp_required
                ? "text.secondary"
                : "text.disabled",
            wordWrap: "break-word",
            whiteSpace: "normal",
            overflowWrap: "anywhere",
          }}
        >
          {min_exp_required || max_exp_required
            ? `${
                min_exp_required
                  ? `Min:  ${min_exp_required} ${
                      min_exp_required && max_exp_required ? "" : " year(s)"
                    }`
                  : ""
              }${min_exp_required && max_exp_required ? " - " : ""}${
                max_exp_required ? `Max: ${max_exp_required} year(s)` : ""
              }`
            : "Not specified"}
        </Typography>
      </Box>
    </Stack>
  );
};
export { AICreateJobFlowDetails, JobInfoPreview };
